import {
  Toast
} from 'vant'
import { Message } from 'element-ui'


var dayjs = require('dayjs') // 时间戳转换插件

/**
 * @param {type} . ellipsis 文本超出显示省略号
 */
const ellipsis = (value, num) => {

  if (!value) return ''
  if (value.length > num) {
    return value.slice(0, num) + '...'
  }
  return value
}

/**
 * @param {type} Time 格式化时间.
 */
const Time = (dataStr, flag, fmt) => {

  const _now = dayjs.unix()
  fmt = fmt || ''

  if (dataStr <= 1000000000000) {
    var listtime = dayjs.unix(dataStr)

  } else {
    var listtime = dayjs(dataStr)


  }
  const diff = _now.diff(listtime, 'h')
  if (flag) {
    if (diff < 1) {
      return '刚刚'
    } else {
      return listtime.format('YYYY年MM月DD日')
    }

  } else {

    return listtime.format(fmt)
  }

}

/**
 * @param {type} size 文件大小的计算.
 */
function convertBytes(size) {
  var oldSize = size
  var temp = size

  if (temp / 1024 < 1) {
    // B
    return getFriendlySize(size) + ' B'
  } else {
    size = size / 1024
  }

  temp = size
  if (temp / 1024 < 1) {
    // B
    // return Math.ceil(size)  + "KB";
    return getFriendlySize(size) + ' KB'
  } else {
    size = size / 1024
  }

  temp = size
  if (temp / 1024 < 1) {
    return getFriendlySize(size) + ' MB'
  } else {
    size = size / 1024
  }

  temp = size
  if (temp / 1024 < 1) {
    // B
    // return Math.ceil(size)  + "GB";
    return getFriendlySize(size) + ' GB'
  } else {
    size = size / 1024
  }

  temp = size
  if (temp / 1024 < 1) {
    // B
    // return Math.ceil(size)  + "TB";
    return getFriendlySize(size) + ' TB'
  } else {
    size = size / 1024
  }

  temp = size
  if (temp / 1024 < 1) {
    // B
    // return Math.ceil(size)  + "PB";
    return getFriendlySize(size) + ' PB'
  } else {
    size = size / 1024
  }

  return '*B'
}
/**
 * @param {type} size 尺寸精度.
 */
function getFriendlySize(size) {
  if (size < 10) {
    return size.toFixed(2)
  } else if (size < 100) {
    return size.toFixed(1)
  } else {
    return Math.ceil(size)
  }
}


/**
 * @param {type} list Process the returned data
 */
function Process_list(list, flag = 1) {

  let allThumbnail = [], // 图片展示列表
    allThumbnailMap = [], // 图片展示map，用于获取图片
    file_list = [],
    arr = []
  let startIndex = 0 // 列表开始的位置
  function path_detail(item, flag = 1) {
    if (!flag) {

      var pathArr = item.display_path.split('/');
    } else {
      var pathArr = item.path.split('/');
    }
    let curFileName = pathArr[pathArr.length - 1];
    item.displayName = curFileName;
    item.record_time = item.mtime * 1000;
    item.mtime = item.mtime * 1000;
    item.isRename = false;
    if (item.type || item.type == 0 && item.type != 'undefined') {
      item.file_type = item.type
    } else {

    }
    if (!item.is_dir) {
      item.suffix = curFileName.substring(curFileName.lastIndexOf('.') + 1).toLowerCase();
    } else {
      item.suffix = 'dir';
    }


    // 视频	1
    // 音频	2
    // 图片	3
    // 文档	4
    // 图片、音频、视频url处理
    let item1 = precess_img(item, allThumbnail, allThumbnailMap)
    return item1
  }
  list.forEach((item) => {
    if (item.is_aggregation) {
      item.aggregation_list.forEach((e) => {
        path_detail(e)
      })

    } else {

      path_detail(item, flag)
    }

  })

  file_list = list;
  return [file_list, allThumbnailMap, allThumbnail]

}
/**
 * @name: precess_img
 * @test: test font
 * @msg: 图片处理
 * @param {item,allThumbnail,allThumbnailMap}
 * @return {*}
 */
function precess_img(item, allThumbnail, allThumbnailMap) {

  // if (imageSuffix.indexOf( item.suffix.toLowerCase()) > -1 || videoSuffix.indexOf(item.suffix.toLowerCase()) > -1) {

  //   item.thumbIndex = allThumbnail.length;
  //   let IP = window.location.hostname;
  //   let PORT = window.location.port??8080;

  //     IP =Device_IP ;

  //   const kid = Cookies.get('kid');
  //   if(item?.display_path){
  //   var StringToSign = encodeURI(item.display_path);
  //   }else{

  //     var StringToSign = encodeURI(item.path);
  //   }


  //   const ssig = getDeviceSsig(StringToSign, kid);

  //   item.url = `http://${IP}:${PORT}${StringToSign}?KID=${kid}&ssig=${ssig}&THUMBNAIL=small`;
  //   item.medurl = `http://${IP}:${PORT}${StringToSign}?KID=${kid}&ssig=${ssig}&THUMBNAIL=median`;

  //   allThumbnail.push(
  //      decodeURIComponent(item.medurl)
  //   );
  //   allThumbnailMap[allThumbnail.length - 1] = allThumbnail.length;
  // } else {
  //   item.url = '';
  // }

  // return [item,allThumbnail,allThumbnailMap]
};

/**
 * @param {type} fn The function that needs to be processed.
 * @param {number} interval delay time.
 * @param {object} option    当需要获取函数返回值或者需要执行最后一次是否需要执行. trailing:boolean是否开始就执行一次;result:返回值
 */

function throttle(fn, interval = 500, option) {
  var last = 0;
  var timer = null;
  if (!option) option = {};

  var trailing = option.trailing || false;
  var result = option.result || null;

  var handleFn = function () {
    // this和argument
    var _this = this;
    var _arguments = arguments;

    var now = new Date().getTime();
    if (now - last > interval) {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }

      callFn(_this, _arguments);
      last = now;
    } else if (timer === null && trailing) { // 只是最后一次
      timer = setTimeout(function () {
        timer = null;
        callFn(_this, _arguments);
      }, interval);
    }
  }

  handleFn.cancel = function () {
    clearTimeout(timer);
    timer = null;
  }

  function callFn(context, argument) {
    var res = fn.apply(context, argument);

    if (!result) {
      return res;
    }
  }

  return handleFn;
}

//转换成分钟
function hourFmt(hourStr) {
  var lateTime = hourStr + (60 * 60 * 24 * 7)
  //当前时间戳
  var timestamp = Math.round(new Date().getTime() / 1000).toString()

  var time = (lateTime - timestamp)
  var  hours= Math.round(time / (60 ))
  return hours
}


//转换成天数
function dayFmt(dayStr) {
  var lateTime = dayStr + (60 * 60 * 24 * 7)
  //当前时间戳
  var timestamp = Math.round(new Date().getTime() / 1000).toString()

  var time = (lateTime - timestamp)
  var day = Math.round(time / (60 * 60 * 24))
  return day
}

//手机号中间四位为星号
function phoneFmt(tel) {

  if (tel.length > 8) {
    var reg = /^(\d{3})\d{4}(\d{4})$/;
    tel = tel.replace(reg, "$1****$2");
  } else {
    var reg = /^(\d{2})\d{5}(\d{1})$/;
    tel = tel.replace(reg, "$1*****$2");
  }

  return tel
}

//防抖：只执行最后一次
export const debounce = (fn, delay) => {
  let timer = null //借助闭包
  return function () {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(fn, delay)
  }
};

export const nativemes = (v) => {
  let obj = JSON.stringify(v);
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isiOS) {
    window.webkit.messageHandlers.request.postMessage(obj);
  } else {
    window.MyJavascriptInterface.request(obj);
  }
};

/**
 * @description: toast提示框
 * @param {*mes:提示信息,type:类型,clear是否是清除}
 * @return {*}
 */
export const toastmes = (mes, type, classname, clear = false, time = 2000) => {

  clear ? Toast.clear() : type == 'fail' ? Toast.fail({
      message: mes,
      className: `fail-toast ${classname}`,
      position: "top"
    }) :
    Toast.success({
      message: mes,
      className: `success-toast ${classname}`,
      position: "top",
      duration: time
    });

}

export const userAgent = () => {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        return true
    }
    return false
}

export const limitMessage = (result) => {
  // 单个文件下载检查是否大于20G，打包下载则每个文件加起来不能大于2G
  const max = result.length === 1 ? 21474836480 : 2147483648
  // const max = 153600
  const sumSize = result.reduce((sumVal, newVal) => sumVal + newVal.size, 0)
  if (sumSize >= max) {
    const num =  '数量' 
    const moreFile = '预览和'
    const mes = `文件过大不支持在线${moreFile}下载，建议保存到时光机后再进行相应操作`

    userAgent() ? Toast.fail({
      message: mes,
      className: `fail-toast`,
      position: "top"
    }) : Message({
      type: "warning",
      message: mes
    })
    return true
  }
  return false
}

const showMessage = Symbol('showMessage')

class gtMessage {
  success(options, single=true) {
    this[showMessage]('success', options, single)
  }
  warning(options, single=true) {
    this[showMessage]('warning', options, single)
  }
  info(options, single=true) {
    this[showMessage]('info', options, single)
  }
  error(options, single=true) {
    this[showMessage]('error', options, single)
  }

  [showMessage](type, options, single) {
    if(single) {
      if(!document.querySelector('.el-message')) {
        Message[type](options)
      }
    } else {
      Message[type](options)
    }
  }
}

export const gtMessageCase = new gtMessage()


export default {
  ellipsis,
  Time,
  convertBytes,
  Process_list,
  throttle,
  hourFmt,
  dayFmt,
  phoneFmt,
  nativemes,
  toastmes,
  limitMessage
}



// WEBPACK FOOTER //
// ./src/utils/utils.js